import Vue from 'global-vue'

import di from 'di'

import { encode } from '@wittignl/js-core/utils/base64'
import { Session } from '@wittignl/js-core/plugins/Authentication'
import createQuery from '@wittignl/js-core/apollo/queries/createQuery'

import InitQuery from 'gql/queries/Init.gql'

export default class EmailAccountType
{
    static NAME = 'email';

    async login(credentials) {

        const basic = encode(`${credentials.username}:${credentials.password}`);

        const response = await Vue.http.post('access_token', { application: credentials.application }, {

            headers: {
                Authorization: `Basic ${basic}`
            }
        });

        const data = response.data.data;
        if(!data){
            throw 'Invalid login response';
        }

        const apollo = di.get('apollo');
        const initResult = await apollo.query(createQuery(InitQuery, {

            context: {
                headers: {
                    Authorization: `Bearer ${data.token}`
                }
            }
        }));

        if(!initResult || !initResult.data || !initResult.data.viewer.user){
            throw 'Invalid init response';
        }

        const user = initResult.data.viewer.user;

        return new Session(EmailAccountType.NAME, user, new Date().getTime(), data.expires, data.token);
    }

    authenticate(identity) {

        return Promise.resolve();
    }

    logout(session) {

        return Promise.resolve();
    }
}
